import { movies } from "@/mocks/movies";
import MovieCard from "@/components/base/MovieCard";

export default function LatestSection() {
  const newMovies = movies.filter((m) => m.isNew);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">最新上线</h2>
          <p className="text-sm text-foreground-500">第一时间为您呈现最新影视资源</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {newMovies.map((movie) => (
          <MovieCard
            key={movie.id}
            id={movie.id}
            title={movie.title}
            category={movie.category}
            year={movie.year}
            rating={movie.rating}
            imageUrl={movie.imageUrl}
          />
        ))}
      </div>
    </section>
  );
}